import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'fr',
    fullName: 'French',
    nativeName: 'Français',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "Quelque chose d'incroyable arrive",
    landing_subtitle: "ArgVoid est un studio de développement d'applications et de jeux. Restez connectés, des nouveautés arrivent bientôt !",
    select_language: "Sélectionnez la langue",
    search_placeholder: "Rechercher des langues...",
    terms_title: "Conditions d'utilisation",
    policy_title: "politique de confidentialité",
    cookies_title: "Politique en matière de cookies",
    terms_content: `
        <strong>1. Acceptation des conditions</strong><br>
        En accédant à ArgVoid, ces conditions d'utilisation sont acceptées. Si ces conditions ne sont pas acceptées, le service ne doit pas être utilisé.<br><br>

        <strong>2. Utilisation de la plateforme</strong><br>
        ArgVoid et ses applications sont fournis « tels quels » à des fins informatives et créatives. Le service doit être utilisé uniquement à des fins licites.<br><br>

        <strong>3. Conduite interdite</strong><br>
        L'exploitation des vulnérabilités du site, le spam ou la tentative d'accès non autorisé à l'infrastructure sont strictement interdits.<br><br>

        <strong>4. Avis de non-responsabilité</strong><br>
        La plateforme et les services peuvent être modifiés à tout moment et sans préavis. Aucune garantie n'est fournie concernant la disponibilité ou la disponibilité du service.
    `,
    policy_content: `
        <strong>1. Collecte d'informations</strong><br>
        La plateforme ne nécessite pas d'authentification des utilisateurs ni de création de compte pour le moment. Aucune information d'identification personnelle (telle que les noms ou les adresses e-mail) n'est activement collectée auprès des visiteurs.<br><br>

        <strong>2. Données d'utilisation</strong><br>
        Des analyses de base anonymisées peuvent être collectées pour comprendre le trafic du site et améliorer les applications. Ces données ne sont pas liées aux identités des utilisateurs individuels.<br><br>

        <strong>3. Services tiers</strong><br>
        Des fournisseurs tiers peuvent être utilisés pour les services d’hébergement et d’analyse. Les pratiques de confidentialité de ces fournisseurs respectifs régissent les données anonymes traitées sur leur infrastructure.<br><br>

        <strong>4. Sécurité des données</strong><br>
        Des mesures de sécurité raisonnables sont mises en œuvre pour protéger la plateforme. Cependant, aucune méthode de transmission sur Internet n’est entièrement sécurisée.<br><br>
    `,
    cookies_content: `
        <strong>1. Que sont les cookies et le stockage local ?</strong><br>
        Les cookies et le stockage local du navigateur sont de petits fichiers de données stockés sur l'appareil pour mémoriser les préférences de configuration lors des visites.<br><br>

        <strong>2. Objectif d'utilisation</strong><br>
        Le stockage local du navigateur est utilisé strictement pour enregistrer les paramètres de configuration, tels que : <br>
        - Préférences de langue<br>
        - Configuration de l'interface utilisateur (par exemple, paramètres de mise en page ou de thème) <br>
        - Cache d'application temporaire<br><br>

        <strong>3. Pas de suivi</strong><br>
        Les cookies et le stockage local ne sont pas utilisés à des fins de publicité ou de suivi par des tiers. Toutes les données stockées sont strictement destinées aux fonctionnalités de base de la plateforme.<br><br>

        <strong>4. Contrôle</strong><br>
        Les données du navigateur peuvent être effacées à tout moment via les paramètres du navigateur, ce qui réinitialisera toutes les configurations locales.
    `,
    cookie_consent_text: "Nous utilisons des cookies de base pour garantir le bon fonctionnement du site Web, comme le maintien de votre session active, l'enregistrement de vos préférences linguistiques et d'autres configurations personnalisées.",
    read_policy: "Lire la politique en matière de cookies",
    support_title: "Contacter l'assistance",
    support_subject_label: "Sujet",
    support_message_label: "Message",
    support_submit_button: "Envoyer un message",
    support_hint: "Remarque : Cela ouvrira votre application de messagerie par défaut pour envoyer le message.",
    support_success_msg: "Ouverture de votre application de messagerie...",
    support_error_msg: "Échec de l'envoi du message. Veuillez réessayer plus tard.",
    explorer_title: "Explorateur",
    history_title: "Histoire",
    animation_title: "Animation",
    config_title: "Configuration",
    tool_mouse: "Sélectionnez (Ctrl+M)",
    tool_brush: "Pinceau (Ctrl+B)",
    tool_brush_mode: "Mode bascule (solide/clair)",
    tool_eraser: "Gomme (Ctrl+E)",
    tool_brush_size: "Ajuster la taille du pinceau",
    tool_bucket: "Remplir (Ctrl+F)",
    tool_eyedropper: "Pipette",
    tool_grid: "Grille (Ctrl+Maj+B)",
    tool_rotate: "Faire pivoter (Ctrl+Maj+R)",
    tool_flip_h: "Retourner H (Ctrl+Maj+H)",
    tool_flip_v: "Retourner V (Ctrl+Maj+V)",
    tool_transpose: "Transposer (Ctrl+Maj+T)",
    label_width: "Largeur",
    label_height: "Hauteur",
    label_frames: "Nombre de cadres",
    label_animation: "Style d'animation",
    label_background_color: "Couleur d'arrière-plan",
    label_interval: "Intervalle",
    tool_anim_config: "Configuration des animations",
    label_new_width: "Nouvelle largeur",
    label_new_height: "Nouvelle hauteur",
    label_apply: "Appliquer",
    label_colors: "Couleurs",
    label_size: "Taille",
    label_tolerance: "Tolérance",
    val_horizontal: "Horizontal",
    val_vertical: "Verticale",
    val_sequence: "Séquence",
    val_bounce: "Rebond",
    val_random: "Aléatoire",
    val_solid: "Solide",
    val_clear: "Clair",
    action_add_sheet: "Nouvelle feuille",
    action_import: "Importer",
    action_export: "Exporter",
    action_sort_projects: "Trier",
    sort_date_old: "Le plus âgé en premier",
    sort_date_new: "Le plus récent en premier",
    sort_name_az: "Nom (A-Z)",
    sort_name_za: "Nom (Z-A)",
    action_new_sprite: "Nouveau Sprite",
    action_new_project: "Nouveau projet",
    modal_save_all_title: "Enregistrer toutes les modifications",
    modal_save_all_desc: "Sélectionnez les actifs à enregistrer :",
    modal_save_selected: "Enregistrer la sélection",
    action_saved: "Enregistré",
    modal_create_sprite_title: "Créer un nouveau sprite",
    modal_create_project_title: "Créer un nouveau projet",
    modal_add_sheet_title: "Ajouter une nouvelle feuille",
    modal_rename_sheet_title: "Renommer la feuille",
    modal_rename_sprite_title: "Renommer le Sprite",
    modal_delete_sprite_title: "Supprimer le sprite",
    modal_delete_project_title: "Supprimer le projet",
    modal_delete_sheet_title: "Supprimer la feuille",
    placeholder_sprite_name: "Nom",
    placeholder_project_name: "Nom",
    placeholder_sheet_name: "Nom",
    placeholder_new_name: "Nouveau nom",
    action_create: "Créer",
    action_add: "Ajouter",
    action_rename: "Rebaptiser",
    action_duplicate: "Double",
    action_delete: "Supprimer",
    action_cancel: "Annuler",
    confirm_delete_sprite: "Êtes-vous sûr de vouloir supprimer ce sprite ?",
    confirm_delete_project: "Êtes-vous sûr de vouloir supprimer ce projet ? Tous les sprites seront supprimés.",
    confirm_delete_sheet: "Êtes-vous sûr de vouloir supprimer cette feuille ?",
    err_select_sprite: "Veuillez d'abord sélectionner un sprite.",
    err_select_project: "Veuillez d'abord sélectionner un projet.",
    err_name_empty: "Le nom ne peut pas être vide.",
    err_sprite_exists: "Un sprite portant ce nom existe déjà.",
    err_project_exists: "Un projet portant ce nom existe déjà.",
    err_no_content: "Aucun contenu à enregistrer.",
    err_no_changes: "Aucune modification à enregistrer.",
    err_delete_last_sheet: "Impossible de supprimer la dernière feuille.",
    err_extract_frames: "Impossible d'extraire des images.",
    err_indexeddb: "Échec de l'enregistrement local. Votre navigateur peut ne pas prendre en charge IndexedDB.",
    msg_upload_success: "Téléchargement réussi : {0}",
    msg_upload_failed: "Échec du téléchargement : {0}",
    msg_save_success: "Sauvegarde réussie.",
    msg_saving: "Économie...",
    msg_multi_save_result: "{0} éléments enregistrés. {1} échecs.",
    menu_title: "Menu",
    menu_save: "Sauvegarder",
    menu_save_all: "Enregistrer tout",
    menu_support: "Contacter l'assistance",
    label_local_storage: "Stockage local",
    label_sign_in: "Se connecter",
    modal_export_title: "Exporter des sprites",
    label_filename: "Nom de fichier",
    label_format: "Format",
    action_export_confirm: "Exporter",
};

export default translations;
